import { Link } from 'react-router';
import { Eye } from 'lucide-react';

/** Lien « voir » d'une ligne de tableau (icône œil), vers la page de l'objet : la feuille d'un employé, par exemple */
export function RowViewLink({
  to,
  label,
}: {
  to: string;
  /** Lu par les lecteurs d'écran : « Voir la feuille de DOE Jane » */ label: string;
}) {
  return (
    <Link
      to={to}
      aria-label={label}
      title={label}
      className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
    >
      <Eye className="w-4 h-4" />
    </Link>
  );
}
